import { useLocation } from "@tanstack/react-router";
import { Map as MapComponent } from "./Map";

interface FooterProps {
  showMap?: boolean;
  backgroundColor?: string;
}

export function Footer({ showMap, backgroundColor }: FooterProps) {
  const location = useLocation();

  // Determine automatic map visibility based on route
  const autoShowMap = location.pathname !== "/contact";
  const finalShowMap = showMap !== undefined ? showMap : autoShowMap;

  // Determine automatic background color based on route and screen size
  const isAboutOrSportPage =
    location.pathname === "/about" || location.pathname === "/sport";
  const autoBackgroundColor = isAboutOrSportPage
    ? "bg-black xl:bg-tennis-900" // black on mobile, tennis-900 on desktop/tablet
    : "bg-tennis-900";
  const finalBackgroundColor =
    backgroundColor !== undefined ? backgroundColor : autoBackgroundColor;
  return (
    <footer className={`tg-section__wrapper ${finalBackgroundColor} py-12 lg:py-25`}>
      <div className="tg-section__grid space-y-6 xl:space-y-0">
        <div className="col-span-12 space-y-6 lg:space-y-12 xl:col-span-3">
          <img
            src="/images/tennis-logo.webp"
            alt="Tennis Gourmet"
            className="h-25 w-auto lg:h-30"
          />
          <div className="space-y-2">
            <p className="tg-body font-bold">Vieni a Trovarci</p>
            <p className="tg-body">
              Via Gregorini, 89<br></br>23017 Morbegno (SO)
            </p>
          </div>
          <div className="space-y-2">
            <p className="tg-body font-bold">Contatti:</p>
            <p>
              Tel.{" "}
              <a href="tel:0342330685" className="underline hover:no-underline">
                0342 330685
              </a>
            </p>
            <p>
              Email:{" "}
              <a
                href="mailto:info@ristorantetennisgourmet.it"
                className="underline hover:no-underline"
              >
                info@ristorantetennisgourmet.it
              </a>
            </p>
          </div>
        </div>
        <div className="col-span-12 space-y-2 lg:pt-42 xl:col-span-3">
          <p className="tg-body font-bold">Orari di apertura</p>
          <div className="space-y-2">
            <p className="tg-body font-bold">Bar</p>
            <p className="tg-body">
              Da martedì a domenica<br></br>09:00 - 23:00
            </p>
          </div>
          <div className="space-y-2">
            <p className="tg-body font-bold">Cucina</p>
            <p className="tg-body">
              Lunedì<br></br>12.00 – 14.30<br></br>Da martedì a domenica<br></br>12:00 –
              14:30 19:00 - 22:00
            </p>
          </div>
        </div>
        {finalShowMap && (
          <MapComponent className="col-span-12 aspect-[16/9] xl:col-span-6" />
        )}
      </div>
    </footer>
  );
}
